import { Button, Spin, Switch } from 'antd';
import { doc } from 'firebase/firestore';
import { getDownloadURL, uploadBytes } from 'firebase/storage';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDocumentData, useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { Input, Label } from '../../../components/UI/Forms/Forms';
import DeleteIcon from '../../../components/UI/Icon-SVG/DeleteIcon';
import FacebookIcon from '../../../components/UI/Icon-SVG/FacebookIcon';
import LinkedinIcon from '../../../components/UI/Icon-SVG/LinkedIn';
import PencilIcon from '../../../components/UI/Icon-SVG/PencilIcon';
import PlusIconLarge from '../../../components/UI/Icon-SVG/PlusIconLarge';
import ProfileIcon from '../../../components/UI/Icon-SVG/ProfileIcon';
import { Context } from '../../../index';

import AddEducation from './components/AddEducation';
import AddJob from './components/AddJob';
import AddPublications from './components/AddPublications';
import AvatarUpload from './components/AvatarUpload';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: auto;
  padding-bottom: 24px;

  .article {
    font-family: Open Sans, sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    margin: 0;
  }

  .article-shadow {
    font-family: Open Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #a6b0cf;
    margin-top: 6px;
  }
`;

const View = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 520px;
`;

const AvatarBlock = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #c6dbff;
  position: relative;
  margin-top: 10px;

  .avatar__none {
    position: absolute;
    top: 26%;
    left: 25%;
  }

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-size: cover;
  }

  .edit {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #397ef3;

    div {
      margin: 2px 0 0 6px;
    }
  }
`;

const NameBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
`;

const ContactBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
`;

const LawyerInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const SmallInput = styled.div`
  width: 48%;
  margin-top: 15px;
  max-width: 254px;
`;

const LargeInput = styled.div`
  width: 100%;
  margin-top: 15px;
`;

const TextArea = styled.textarea`
  display: block;
  outline: none;
  border-top: none;
  border-right: none;
  border-left: none;
  font-size: 16px;
  border-bottom: 1px solid #397cf3;
  padding: 10px 0;
  color: black;
  width: 100%;
`;

const Gallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

const AddPhoto = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #397ef3;
  width: 88px;
  height: 88px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 18px;
  margin-bottom: 18px;

  span {
    color: #397ef3;
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
  }

  svg path {
    fill: #397ef3;
  }
`;

const PhotoWrapper = styled.div`
  position: relative;
`;
const DeleteIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 20px;
  cursor: pointer;
`;

const DeleteIconWrapperInList = styled.div`
  position: absolute;
  top: 0px;
  right: -12px;
  cursor: pointer;
  z-index: 3;
`;

const Photo = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 5px;
  margin-right: 18px;
  background: #a6b0cf;
  margin-bottom: 18px;
`;

const AdditionalData = styled.div`
  margin-top: 24px;
`;
const Сareer = styled.div`
  width: 100%;
`;
const Education = styled.div`
  width: 100%;
`;
const Publications = styled.div`
  width: 100%;
`;

const AddItem = styled.p`
  color: #397ef3;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
`;

const SocialBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const InputIcon = styled.div`
  position: absolute;
  left: 5px;
  top: 10px;
  z-index: 2;
`;

const SwitcherContainer = styled.div`
  width: 100px;
  margin-top: 14px;
  margin-right: 20px;
`;

const SwitcherWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  border-bottom: 1px solid #397cf3;

  p {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin-right: 10px;
  }
`;

const AvatarEdit = styled.div`
  cursor: pointer;
`;

const ProfileItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Text = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0;
`;

const ShadowText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0;
  color: #a6b0cf;
`;

const PublicationsItem = styled.a`
  color: #397ef3;
  font-size: 16px;
  margin-top: 12px;
  font-family: 'Open Sans', sans-serif;
  display: block;
`;

const Publication = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  display: block;
  background: #fff;
  overflow: auto;
`;

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: 20px;
`;

const EditProfileLawyer = () => {
  const [uploading, setUploading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({});
  const { auth, firestore, storage } = useContext(Context);
  const user = auth.currentUser;
  const userId = user?.uid;
  const ref = useRef();
  const addJobRef = useRef();
  const addEducationRef = useRef();
  const addPublicationRef = useRef();
  const history = useHistory();

  const [userData] = useDocumentDataOnce(doc(firestore, 'users', userId));
  const [lawyerFullProfileData] = useDocumentDataOnce(
    doc(firestore, 'lawyer_full_profile', userId),
  );
  const [forAvatar] = useDocumentData(doc(firestore, 'lawyer_full_profile', userId));
  const { avatar } = forAvatar ?? {};

  useEffect(() => {
    setForm({
      first_name: userData?.first_name || '',
      last_name: userData?.last_name || '',
      practice_area: lawyerFullProfileData?.lawyerFullProfileData || '',
      user_location: lawyerFullProfileData?.user_location || '',
      about: lawyerFullProfileData?.about || '',
      hourly_rate: lawyerFullProfileData?.hourly_rate || '',
      free_consultation: lawyerFullProfileData?.free_consultation || false,
      office_address: lawyerFullProfileData?.office_address || '',
      office_phone: lawyerFullProfileData?.office_phone || '',
      email: lawyerFullProfileData?.email || '',
      office_site: lawyerFullProfileData?.office_site || '',
      linkedin: lawyerFullProfileData?.linkedin || '',
      facebook: lawyerFullProfileData?.facebook || '',
      photos: lawyerFullProfileData?.photos || [],
      career: lawyerFullProfileData?.career || [],
      education: lawyerFullProfileData?.education || [],
      publications: lawyerFullProfileData?.publications || [],
    });
  }, [userData, lawyerFullProfileData]);

  const showUploadAvatarModal = () => {
    ref.current?.showModal();
  };

  const showAddJobModal = () => {
    addJobRef.current?.showModal();
  };

  const showAddEducationModal = () => {
    addEducationRef.current?.showModal();
  };

  const showAddPublicationModal = () => {
    addPublicationRef.current?.showModal();
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeHourlyRate = (e) => {
    setForm({
      ...form,
      hourly_rate: e.target.value?.split('$')?.[1],
    });
  };

  const handleChangeFreeConsultation = (checked) => {
    setForm({
      ...form,
      free_consultation: checked,
    });
  };

  const handleSelectPhoto = (event) => {
    const file = event.target.files?.[0];
    setUploading(true);
    const extension = file?.name?.split('.')?.pop();
    const fileName = `${userId}_${uuidv4()}.${extension}`;
    const ref = storage.ref(`${userId}/${fileName}`);
    uploadBytes(ref, file)
      .then((snapshot) =>
        getDownloadURL(snapshot.ref).then((downloadURL) => {
          const avatar = {
            avatar_name: fileName,
            avatar_path: downloadURL,
            avatar_description: '',
          };
          form.photos.push(avatar);
        }),
      )
      .catch(() => alert('Uploading failed'))
      .finally(() => setUploading(false));
  };

  const removePhoto = (index) => {
    form.photos.splice(index, 1);
    setForm({
      ...form,
    });
  };

  const removeCareer = (index) => {
    form.career.splice(index, 1);
    setForm({
      ...form,
    });
  };

  const removeEducation = (index) => {
    form.education.splice(index, 1);
    setForm({
      ...form,
    });
  };

  const removePublications = (index) => {
    form.publications.splice(index, 1);
    setForm({
      ...form,
    });
  };

  const addCareer = (data) => {
    form.career.push(data);
    setForm({
      ...form,
    });
  };

  const addEducation = (data) => {
    form.education.push(data);
    setForm({
      ...form,
    });
  };

  const addPublications = (data) => {
    form.publications.push(data);
    setForm({
      ...form,
    });
  };

  const back = () => history.goBack();

  const save = async () => {
    setIsLoading(true);
    await firestore.collection('users').doc(userId).update({
      first_name: form.first_name,
      last_name: form.last_name,
    });
    delete form.first_name;
    delete form.last_name;
    await firestore
      .collection('lawyer_full_profile')
      .doc(userId)
      .update({
        ...form,
      });
    setIsLoading(false);
    back();
  };

  const isInvalid = !(form.first_name && form.last_name);

  return (
    <Wrapper>
      <Container>
        <AvatarUpload isLawyer ref={ref} />
        <AddJob onSave={addCareer} ref={addJobRef} />
        <AddEducation onSave={addEducation} ref={addEducationRef} />
        <AddPublications onSave={addPublications} ref={addPublicationRef} />
        <View>
          <p className="article">General information</p>
          <AvatarBlock>
            {!avatar?.avatar_path ? (
              <div className="avatar__none">
                <ProfileIcon color="#397EF3" />
              </div>
            ) : (
              <img src={avatar.avatar_path} alt="Avatar" />
            )}
            <AvatarEdit className="edit" onClick={showUploadAvatarModal}>
              <PencilIcon />
            </AvatarEdit>
          </AvatarBlock>
          <NameBlock>
            <SmallInput>
              <Label>
                First Name
                <Input value={form?.first_name} onChange={handleChange} name="first_name" />
              </Label>
            </SmallInput>
            <SmallInput>
              <Label>
                Last Name
                <Input value={form?.last_name} onChange={handleChange} name="last_name" />
              </Label>
            </SmallInput>
          </NameBlock>
          <LargeInput>
            <Label>
              About
              <TextArea value={form?.about} onChange={handleChange} name="about">
                {form?.about}
              </TextArea>
            </Label>
          </LargeInput>
          <SmallInput>
            <Label>
              Sphere of law
              <Input value={form?.practice_area} onChange={handleChange} name="practice_area" />
            </Label>
          </SmallInput>
          <LawyerInfo>
            <SwitcherContainer>
              <Label>
                Free consultation
                <SwitcherWrapper>
                  <p>{form?.free_consultation ? 'Yes' : 'No'}</p>
                  <Switch
                    checked={form?.free_consultation}
                    onChange={handleChangeFreeConsultation}
                  />
                </SwitcherWrapper>
              </Label>
            </SwitcherContainer>
            <SmallInput>
              <Label>
                Location
                <Input
                  value={form?.user_location}
                  name="user_location"
                  placeholder="Enter location"
                  onChange={handleChange}
                />
              </Label>
            </SmallInput>
            <SmallInput>
              <Label>
                Hourly payment
                <Input
                  value={`$${form?.hourly_rate}`}
                  name="hourly_rate"
                  onChange={handleChangeHourlyRate}
                  maxLength={5}
                  placeholder="Enter amount and currency"
                />
              </Label>
            </SmallInput>
          </LawyerInfo>
          <ContactBlock>
            <SmallInput>
              <Label>
                Address
                <Input
                  value={form?.office_address}
                  onChange={handleChange}
                  name="office_address"
                  placeholder="Enter address"
                />
              </Label>
            </SmallInput>
            <SmallInput>
              <Label>
                Office phone number
                <Input
                  value={form?.office_phone}
                  onChange={handleChange}
                  name="office_phone"
                  placeholder="Enter office phone number"
                />
              </Label>
            </SmallInput>
            <SmallInput>
              <Label>
                Email
                <Input
                  value={form?.email}
                  name="email"
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </Label>
            </SmallInput>
            <SmallInput>
              <Label>
                Website
                <Input
                  value={form?.office_site}
                  name="office_site"
                  onChange={handleChange}
                  placeholder="Enter website"
                />
              </Label>
            </SmallInput>
          </ContactBlock>
        </View>
        <View style={{ marginLeft: 120 }}>
          <p className="article">Photos</p>
          <p className="article-shadow">Everything about me: certificates, diplomas, etc.</p>
          <Gallery>
            <AddPhoto htmlFor="photos">
              {uploading ? <Spin /> : <PlusIconLarge />}
              <span>Add Photo</span>
            </AddPhoto>
            <input
              type="file"
              accept="image/png, image/jpeg"
              id="photos"
              onChange={handleSelectPhoto}
              style={{ display: 'none' }}
            />
            {form?.photos?.map((item, key) => (
              <PhotoWrapper key={JSON.stringify(item)}>
                <DeleteIconWrapper onClick={() => removePhoto(key)}>
                  <DeleteIcon />
                </DeleteIconWrapper>
                <Photo src={item.avatar_path} />
              </PhotoWrapper>
            ))}
          </Gallery>
          <AdditionalData style={{ marginTop: 32 }}>
            <Сareer>
              <p className="article">Сareer</p>
              {form?.career?.map((item, key) => (
                <ProfileItem key={key} style={{ marginTop: 16 }}>
                  <DeleteIconWrapperInList onClick={() => removeCareer(key)}>
                    <DeleteIcon />
                  </DeleteIconWrapperInList>
                  <Text>{item.career_name}</Text>
                  <ShadowText>
                    {item.career_start} - {item.career_end === '-1' ? 'now' : item.career_end}
                  </ShadowText>
                </ProfileItem>
              ))}
              <AddItem onClick={showAddJobModal}>+ Add a job</AddItem>
            </Сareer>
          </AdditionalData>
          <AdditionalData>
            <Education>
              <p className="article">Education</p>
              {form?.education?.map((item, key) => (
                <ProfileItem key={key} style={{ marginTop: 16 }}>
                  <DeleteIconWrapperInList onClick={() => removeEducation(key)}>
                    <DeleteIcon />
                  </DeleteIconWrapperInList>
                  <Text>{item.education_name}</Text>
                  <ShadowText>{item.education_degree}</ShadowText>
                </ProfileItem>
              ))}
              <AddItem onClick={showAddEducationModal}>+ Add Education</AddItem>
            </Education>
          </AdditionalData>
          <AdditionalData>
            <Publications>
              <p className="article">Publications</p>
              {form?.publications?.map((item, key) => (
                <Publication>
                  <DeleteIconWrapperInList onClick={() => removePublications(key)}>
                    <DeleteIcon />
                  </DeleteIconWrapperInList>
                  <PublicationsItem key={key} href={item.publication_url} target="_blank">
                    {item.publication_name}
                  </PublicationsItem>
                </Publication>
              ))}
              <AddItem onClick={showAddPublicationModal}>+ Add Publications</AddItem>
            </Publications>
          </AdditionalData>
          <SocialBlock>
            <p className="article">Social network</p>
          </SocialBlock>
          <SmallInput>
            <Label>
              <InputIcon>
                <FacebookIcon />
              </InputIcon>
              <Input
                style={{ paddingLeft: 35 }}
                value={form?.facebook}
                name="facebook"
                onChange={handleChange}
                placeholder="Add link to Facebook"
              />
            </Label>
          </SmallInput>
          <SmallInput>
            <Label>
              <InputIcon>
                <LinkedinIcon />
              </InputIcon>
              <Input
                style={{ paddingLeft: 35 }}
                value={form?.linkedin}
                name="linkedin"
                onChange={handleChange}
                placeholder="Add link to Linkedin"
              />
            </Label>
          </SmallInput>
        </View>
      </Container>
      <BtnsWrapper>
        <Button onClick={back} style={{ marginRight: 10, width: 200 }}>
          Cancel
        </Button>
        <Button
          type="primary"
          disabled={isInvalid || isLoading}
          style={{ width: 200 }}
          onClick={save}
        >
          Save
        </Button>
      </BtnsWrapper>
    </Wrapper>
  );
};

export default EditProfileLawyer;
